<template>
  <div class="donut-wrapper">
    <p class="list__header mb-4">{{ title }}</p>

    <div v-if="loading" class="d-flex justify-center py-6">
      <v-progress-circular indeterminate />
    </div>

    <div v-else>
      <ApexChart
        type="donut"
        :width="width"
        :height="height"
        :options="options"
        :series="series"
      />

      <p v-if="showTotal && totalMonto !== null" class="amount-summary mt-3">
        Total del período: <b>S/ {{ totalMonto.toLocaleString('es-PE') }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'IncomesBySectionDonut',
  props: {
    title: {
      type: String,
      default: 'Ingresos por sección (porcentaje)'
    },
    width: {
      type: [String, Number],
      default: 420
    },
    height: {
      type: [String, Number],
      default: 320
    },
    showTotal: {
      type: Boolean,
      default: true
    },
    globalStartDate: {
      type: String,
      default: null
    },
    globalEndDate: {
      type: String,
      default: null
    },
    globalCategories: {
      type: Array,
      default: () => [] 
    },
    globalCategory:{ 
      type: String,
      default: null 
    },
    includeInactive: {
      type: Boolean,
      default: false 
    }
  },
  data () {
    return {
      loading: false,
      series: [],
      totalMonto: null,
      options: {
        labels: [],
        legend: { position: 'bottom' },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`
        },
        tooltip: {
          y: { formatter: (val) => `S/ ${Number(val || 0).toLocaleString('es-PE')}` }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                total: {
                  show: true,
                }
              }
            }
          }
        }
      }
    }
  },
  watch: {
    globalStartDate: 'fetchData',
    globalEndDate: 'fetchData',
    globalCategories: 'fetchData',
    includeInactive: 'fetchData',
  },
  methods: {
    buildQuery () {
      const params = new URLSearchParams()
      if (this.globalStartDate) params.set('fecha_inicio', this.globalStartDate)
      if (this.globalEndDate)   params.set('fecha_fin',    this.globalEndDate)
      const catsArray = Array.isArray(this.globalCategories)? this.globalCategories.filter(Boolean)
      : []
      if (!catsArray.length && this.globalCategory) {
      catsArray.push(this.globalCategory)
       }
      catsArray.forEach(slug => params.append('categoria', slug))
      if (this.includeInactive) {
      params.set('include_inactive', '1')
      }
      return params.toString()
    },
    async fetchData () {
      this.loading = true
      try {
        const qs = this.buildQuery()
        const { data } = await axios.get(`api/admin/graficas/ingresos_por_seccion/${qs ? '?' + qs : ''}`)

        const labels = (data || []).map(i => i.seccion_nombre || '—')
        const values = (data || []).map(i => Number(i.monto_total || 0))

        this.options = { ...this.options, labels }
        this.series = values

        const total = values.reduce((a, b) => a + (Number(b) || 0), 0)
        this.totalMonto = Number(total.toFixed(2))
      } catch (e) {
        console.error('Error cargando ingresos_por_seccion:', e)
        this.series = []
        this.totalMonto = 0
        this.options = { ...this.options, labels: [] }
      } finally {
        this.loading = false
      }
    },
    clearFiltersAndReload() {
      this.fetchData()
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>

<style scoped>
.list__header {
  margin: 0;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;
  color: #455A64;
}
.donut-wrapper {
  width: 100%;
  background: #FFF;
  border-radius: 15px;
  padding: 18px 20px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: 14px;
  height: 460px;
}
.amount-summary {
  margin-top: 4px;
  font-size: 13px;
  color: #455A64;
  text-align: center;  
}
</style>
